import { RecuperarContrasenaForm } from '../ui/RecuperarContrasenaForm';
import { ZafiroLogo } from '@/shared/components/ZafiroLogo';
import '../ui/LoginForm.css';

export const RecuperarContrasena = () => {
  return (
    <div className="login-container">
      <div className="login-content">
        {/* Logo fuera del formulario */}
        <div className="login-logo-section">
          <ZafiroLogo />
        </div>

        <div className="login-card">
          {/* Header */}
          <div className="login-header">
            <h1>Recuperar Contraseña</h1>
            <p>Ingresa tu correo o usuario</p>
          </div>

          <div className="login-form-content">
            <RecuperarContrasenaForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecuperarContrasena;
